import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-discard-group-dialog',
  templateUrl: './discard-group-dialog.component.html',
  styleUrls: ['./discard-group-dialog.component.scss']
})
export class DiscardGroupDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
  }

  discard() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }

}
